import {atom, selectorFamily} from 'recoil';
import {createQuery} from '../../../../../global/lib';
import {api} from '../../../../../global/api';
import {serialize} from '../../../../../shared/utils/serialize-query-params';
import {ToastHelpers} from '../../../../../shared/helpers/toastHelpers';

const {getDashboardServiceRequests} = api.dashboard;

const getDashboardServiceRefresh = atom<number>({
  key: 'getDashboardServiceRefresh',
  default: 0,
});

const getDashboardServiceRequestsQuery = selectorFamily({
  key: 'getDashboardServiceRequests',
  get(params: Parameters<typeof getDashboardServiceRequests>[0]) {
    return async ({get}) => {
      get(getDashboardServiceRefresh);
      try {
        const {data} = await getDashboardServiceRequests(params, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetDashboardServiceRequestsQuery = createQuery(
  getDashboardServiceRequestsQuery,
  getDashboardServiceRefresh,
);

export type GetDashboardServiceRequestsQueryParams = Parameters<typeof getDashboardServiceRequests>[0];
